import React, { useEffect, useRef, useState } from "react";
import {
  Container,
  Form,
  InputGroup,
  Col,
  Row,
  Button,
  Table,
} from "react-bootstrap";
import "./RtuSettingPage.scss";
import PaginatedItems from "components/common/PaginatedItems";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { apiWrapper } from "apis/CommonApi";
import * as rtuSettingApi from "../apis/RtuSettingApi";
import { SERVER_HOST } from "Constants";
import { convertNumberToHex } from "utils/number";
import {
  getEnergyTypeName,
  getRtuAckTypeName,
  getRtuOperationModeName,
  getUartBaudRateName,
  getUartInterfaceName,
  getUseName,
} from "utils/common";
import Loading from "components/common/Loading";

export default function RtuSettingPage() {
  const itemsPerPage = 100;
  const navigate = useNavigate();
  const location = useLocation();
  const searchTextRef = useRef(null);
  const fileInputRef = useRef(null);
  const [dataSource, setDataSource] = useState([]);
  const [previous, setPrevious] = useState(null);
  const [next, setNext] = useState(null);
  const [page, setPage] = useState(1);
  const [checkIds, setCheckIds] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (location.state?.condition) {
      const condition = location.state?.condition;
      if (searchTextRef) {
        searchTextRef.current.value = condition.rtuImei;
      }
    }

    getData(1);
  }, []);

  const handleDownloadExcel = (e) => {
    apiWrapper(async () => {
      const { rtuImei } = getSearchParams();
      const result = await rtuSettingApi.exportExcelRtuSettings(
        rtuImei,
        page,
        itemsPerPage
      );

      const { status, data } = result;
      if (status === false) {
        alert(`엑셀 저장에 실패하였습니다.\n${data}`);
      }
    });
  };

  const handleUpload = (e) => {
    e.preventDefault();

    const file = e.target.files[0];
    if (file) {
      const requestBody = new FormData();
      requestBody.append("file", file);

      apiWrapper(async () => {
        let result = await rtuSettingApi.importExcel(requestBody);

        const { status, data } = result;
        if (status === true) {
          alert("파일 일괄등록 성공하였습니다.");

          getData(1);
        } else {
          alert(`파일 일괄등록 실패하였습니다.\n${data}`);
        }
      });
    }
  };

  const handleAdd = (e) => {
    navigate("/rtu-setting/detail/", {
      state: {
        prevUrl: location.pathname,
        condition: { rtuImei: searchTextRef.current?.value },
      },
    });
  };

  const handleDelete = (e) => {
    if (checkIds.length < 1) {
      alert("삭제할 항목을 선택하세요.");
    } else if (window.confirm("삭제하시겠습니까?")) {
      apiWrapper(async () => {
        const requestBody = { ids: checkIds };
        const result = await rtuSettingApi.deleteRtuSettings(requestBody);

        const { status, data } = result;
        if (status === true) {
          alert("삭제되었습니다.");
          getData(page);
        } else {
          alert(`삭제 실패하였습니다.\n${data}`);
        }
      });
    }
  };

  //page: 1베이스
  const getData = (page, url = null) => {
    apiWrapper(async () => {
      setIsLoading(true);
      let result;
      if (url !== null) {
        result = await rtuSettingApi.getRtuSettingsByUrl(url);
      } else {
        const { rtuImei } = getSearchParams();

        result = await rtuSettingApi.getRtuSettings(
          rtuImei,
          page,
          itemsPerPage
        );
      }
      setIsLoading(false);

      const { status, data } = result;
      if (status === true) {
        setDataSource(data);

        setPrevious(data.previous);
        setNext(data.next);
        setPage(page);
      }
    });
  };

  const getSearchParams = () => {
    let params = { rtuImei: null };

    if (searchTextRef.current && searchTextRef.current?.value !== "") {
      params = { ...params, rtuImei: searchTextRef.current?.value };
    }

    return params;
  };

  const handlePageClick = (e) => {
    if (typeof e.nextSelectedPage !== "undefined") {
      const selectedPage = e.nextSelectedPage + 1;
      let url = null;
      if (e.isPrevious) {
        url = previous;
      } else if (e.isNext) {
        url = next;
      }

      getData(selectedPage, url);
    }
  };

  const handleSearch = (e) => {
    e.preventDefault();
    getData(1);
  };

  const handleChangeCheckAll = (e) => {
    if (dataSource.results) {
      if (e.target.checked) {
        //전체 체크
        let allIds = [];
        dataSource.results.map((item, index) => {
          allIds.push(item.id);
        });

        setCheckIds(allIds);
      } else {
        //전체 체크 해제
        setCheckIds([]);
      }
    }
  };

  const handleChangeCheck = (e, id) => {
    if (e.target.checked) {
      setCheckIds([...checkIds, id]);
    } else {
      setCheckIds(checkIds.filter((a) => a !== id));
    }
  };

  return (
    <>
      <Container fluid className="mb-3 d-flex align-items-center">
        <h1>RTU 설정</h1>
      </Container>

      <Container fluid className="mb-3 d-flex align-items-center">
        <Form onSubmit={handleSearch}>
          <Row className="align-items-center">
            <Col xs={"auto"}>
              <InputGroup>
                <InputGroup.Text>RTU IMEI</InputGroup.Text>
                <Form.Control
                  ref={searchTextRef}
                  style={{ width: "300px" }}
                  placeholder="검색할 문자열을 입력하세요."
                />
                <Button
                  type="submit"
                  variant="primary"
                  style={{ width: "130px" }}
                >
                  검색
                </Button>
              </InputGroup>
            </Col>
          </Row>
        </Form>
        <span className="ms-auto">
          <Button
            className="ms-2"
            variant="primary"
            onClick={handleDownloadExcel}
          >
            엑셀 내려받기
          </Button>
          <a
            href={
              SERVER_HOST + `/media/sample/alliothub_rtu_setting_sample.xlsx`
            }
          >
            <Button className="ms-2" variant="primary">
              샘플
            </Button>
          </a>
          <Button
            className="ms-2"
            variant="primary"
            onClick={() => fileInputRef.current?.click()}
          >
            파일 추가
          </Button>
          <input
            ref={fileInputRef}
            style={{ display: "none" }}
            type="file"
            accept=".xlsx"
            onChange={handleUpload}
          />
          <Button className="ms-2" variant="primary" onClick={handleAdd}>
            추가
          </Button>
          <Button className="ms-2" variant="primary" onClick={handleDelete}>
            삭제
          </Button>
        </span>
      </Container>

      {isLoading ? (
        <Loading />
      ) : (
        <div className="rtu-set-table">
          <div className="table-table">
            <Table
              bordered
              hover
              style={{ overflowX: "auto", whiteSpace: "nowrap" }}
            >
              <thead className="table-header">
                <tr>
                  <th rowSpan="2">
                    <input
                      type="checkbox"
                      style={{ zoom: 1.0 }}
                      className="form-check-input"
                      onChange={handleChangeCheckAll}
                    />
                  </th>
                  <th rowSpan="2">ID</th>
                  <th rowSpan="2">RTU IMEI</th>
                  <th colSpan="7">Header Set</th>
                  <th colSpan="2">UART</th>
                  <th colSpan="2">Network</th>
                  <th colSpan="8">Polling Control Order</th>
                  <th colSpan="1">Polling Query</th>
                  <th colSpan="4">FW Download</th>
                  <th colSpan="6">REMS Control Order</th>
                </tr>
                <tr>
                  <th>사업자 ID</th>
                  <th>서비스 ID</th>
                  <th>RTU 동작 모드</th>
                  <th>RESERVED</th>
                  <th>Ack 타입</th>
                  <th>Ack 예비1</th>
                  <th>Ack 예비2</th>
                  <th>UART 인터페이스</th>
                  <th>UART BAUDRATE</th>
                  <th>서버 URL</th>
                  <th>서버 PORT</th>
                  <th>Boot 완료 메시지 출력 여부</th>
                  <th>UPLOAD 완료 메시지 출력 여부</th>
                  <th>설비 미 응답 메시지 전송 여부</th>
                  <th>설비 Polling 쿼리 주기(분)</th>
                  <th>설비 Polling 쿼리 실행 간격(초)</th>
                  <th>설비 Polling 쿼리 응답 대기 시간</th>
                  <th>실행할 Polling 쿼리 사용 개수(최대 20개)</th>
                  <th>응답 받은 데이터에 쿼리 Index 번호 구분 여부</th>
                  <th>연동된 설비에 실행할 쿼리 커맨드</th>
                  <th>펌웨어 다운로드 URL</th>
                  <th>펌웨어 다운로드 파일명</th>
                  <th>펌웨어 다운로드 접속 ID</th>
                  <th>펌웨어 다운로드 접속 PW</th>
                  <th>REMS 에너지타입</th>
                  <th>Multi 연동수</th>
                  <th>설비1Add</th>
                  <th>설비2Add</th>
                  <th>설비3Add</th>
                  <th>설비4Add</th>
                </tr>
              </thead>
              <tbody className="table-body">
                {dataSource.results &&
                  dataSource.results.map((item, index) => (
                    <tr key={index}>
                      <td>
                        <input
                          type="checkbox"
                          style={{ zoom: 1.0 }}
                          className="form-check-input"
                          onChange={(e) => handleChangeCheck(e, item.id)}
                          checked={checkIds.includes(item.id)}
                        />
                      </td>
                      <td>
                        <Link
                          to={`/rtu-setting/detail/${item.id}`}
                          state={{
                            id: item.id,
                            prevUrl: location.pathname,
                            condition: {
                              rtuImei: searchTextRef.current?.value,
                            },
                          }}
                        >
                          {item.id}
                        </Link>
                      </td>
                      <td>{item.rtuImei}</td>
                      <td>
                        {item.businessId !== null
                          ? convertNumberToHex(item.businessId)
                          : item.businessId}
                      </td>
                      <td>
                        {item.serviceId !== null
                          ? convertNumberToHex(item.serviceId)
                          : item.serviceId}
                      </td>
                      <td>{getRtuOperationModeName(item.opMode)}</td>
                      <td>{item.reserved}</td>
                      <td>{getRtuAckTypeName(item.ackType)}</td>
                      <td>{item.ackValue1}</td>
                      <td>{item.ackValue2}</td>
                      <td>{getUartInterfaceName(item.uartInterface)}</td>
                      <td>{getUartBaudRateName(item.uartBaudrate)}</td>
                      <td>{item.serverUrl}</td>
                      <td>{item.serverPort}</td>
                      <td>{getUseName(item.bootMsg)}</td>
                      <td>{getUseName(item.uploadMsg)}</td>
                      <td>{getUseName(item.noResponseMsg)}</td>
                      <td>{item.period}</td>
                      <td>{item.interval}</td>
                      <td>{item.waitTime}</td>
                      <td>{item.queryCount}</td>
                      <td>{getUseName(item.queryIndex)}</td>
                      <td>{item.rtuQuery}</td>
                      <td>{item.fwDlUrl}</td>
                      <td>{item.fwDlFileName}</td>
                      <td>{item.fwDlId}</td>
                      <td>{item.fwDlPw}</td>
                      <td>{getEnergyTypeName(item.energyType)}</td>
                      <td>{item.multiCount}</td>
                      <td>{item.multi1Address}</td>
                      <td>{item.multi2Address}</td>
                      <td>{item.multi3Address}</td>
                      <td>{item.multi4Address}</td>
                    </tr>
                  ))}
              </tbody>
            </Table>
          </div>
          <div style={{ marginTop: 20 }}>
            <PaginatedItems
              totalItemsCount={dataSource.count}
              itemsPerPage={itemsPerPage}
              selectedPage={page - 1}
              onClick={handlePageClick}
            />
          </div>
        </div>
      )}
    </>
  );
}
